export enum ExposurePathway {
  ORAL = 'ORAL',

  INHALATION = 'INHALATION',

  DERMAL = 'DERMAL',

  INJECTION = 'INJECTION',
}
